import './TagsManagement.scss';
import { QueueManagementConstants } from './../../QueueManagementConstants';
import { TagsQueueTracks } from './TagsQueueConstants';
export class TagsContainerController {
    static $inject = ['LoadingService', 'TagsQueueService', 'PermissionsService', 'SegmentService'];
    constructor(LoadingService, TagsQueueService, PermissionsService, SegmentService) {
        this.LoadingService = LoadingService;
        this.TagsQueueService = TagsQueueService;
        this.PermissionsService = PermissionsService;
        this.SegmentService = SegmentService;
        this.tags = [];
        this.queue = {};
        this.currentState = QueueManagementConstants.STATES.VIEWING;
        this.isViewing = QueueManagementConstants.STATES.VIEWING;
        this.isAdding = QueueManagementConstants.STATES.ADDING;
        this.isEdit = QueueManagementConstants.STATES.EDITING;
        this.onTagsChange = async (event) => {
            const { data, value } = event.detail;
            if (this.tags.length < data.length) {
                this.isLoading = true;
                await this.saveTagsAttendanceQueue(value);
                this.tags.push(value);
            }
            if (this.tags.length > data.length) {
                this.isLoading = true;
                await this.deleteTagsAttendanceQueue(data);
            }
            this.isLoading = false;
            return;
        };
    }
    async $onInit() {
        this.setIsLoading(false);
        if (this.queue) {
            this.tagsQueue = await this.TagsQueueService.getTagsQueue(this.queue.uniqueId);
            this.tags = this.tagsQueue.map(t => t.tag);
        }
        this.canEditTag = await this.PermissionsService.hasPermissions(QueueManagementConstants.WRITE, QueueManagementConstants.DESK);
    }
    setCurrentState(state) {
        this.currentState = state;
    }
    setIsLoading(isLoading) {
        this.isLoading = isLoading;
    }
    async saveTagsAttendanceQueue(tag) {
        const tags = await this.TagsQueueService.set(this.application, tag, this.queue.uniqueId);
        this.tagsQueue.push(tags);
        this.SegmentService.createApplicationTrack({
            trackEvent: TagsQueueTracks.ADD_TAG_QUEUE,
            application: this.application,
            payload: { tagNumber: this.tagsQueue.length },
        });
    }
    async deleteTagsAttendanceQueue(tags) {
        const tagsRemoved = this.tagsQueue.filter((tag) => !tags.some(t => tag.tag === t));
        await this.TagsQueueService.delete(tagsRemoved, this.queue.uniqueId);
        this.tagsQueue = this.tagsQueue.filter(tag => !tagsRemoved.some(t => tag?.id === t?.id));
        this.tags = tags;
        this.SegmentService.createApplicationTrack({
            trackEvent: TagsQueueTracks.REMOVE_TAG_QUEUE,
            application: this.application,
            payload: { tagNumber: this.tagsQueue.length },
        });
    }
}
TagsContainerController.$inject = ['LoadingService', 'TagsQueueService', 'PermissionsService', 'SegmentService'];
